import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:shadow-md group-[.toaster]:rounded-r-md group-[.toaster]:font-semibold group-[.toaster]:bg-neutral-light-1 group-[.toaster]:text-neutral-dark-2 group-[.toaster]:border-l-[5px] group-[.toaster]:border-neutral-medium-2 group-[.toaster]:border-t-0 group-[.toaster]:border-r-0 group-[.toaster]:border-b-0',
          description:
            'group-[.toast]:font-normal group-[.toast]:!text-inherit group-[.toast]:opacity-100',
          closeButton:
            'group-[.toast]:!bg-neutral-medium-1 group-[.toast]:!border-neutral-medium-1 group-[.toast]:!text-neutral-dark-1',
          actionButton:
            'group-[.toast]:bg-brand-dark-3 group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-neutral-medium-1 group-[.toast]:text-neutral-dark-1',
          success:
            'group toast group-[.toaster]:!bg-success-light-1 group-[.toaster]:!text-success-dark-1 group-[.toaster]:!border-l-[5px] group-[.toaster]:!border-l-success-dark-1 group-[.toaster]:shadow-md group-[.toaster]:rounded-r-md group-[.toaster]:font-semibold [&_*]:!text-success-dark-1',
          error:
            'group toast group-[.toaster]:!bg-danger-light-1 group-[.toaster]:!text-danger-dark-1 group-[.toaster]:!border-l-[5px] group-[.toaster]:!border-l-danger-dark-1 group-[.toaster]:shadow-md group-[.toaster]:rounded-r-md group-[.toaster]:font-semibold [&_*]:!text-danger-dark-1',
          warning:
            'group toast group-[.toaster]:!bg-warning-light-1 group-[.toaster]:!text-warning-dark-1 group-[.toaster]:!border-l-[5px] group-[.toaster]:!border-l-warning-dark-1 group-[.toaster]:shadow-md group-[.toaster]:rounded-r-md group-[.toaster]:font-semibold [&_*]:!text-warning-dark-1',
          info: 'group toast group-[.toaster]:!bg-info-light-1 group-[.toaster]:!text-info-dark-1 group-[.toaster]:!border-l-[5px] group-[.toaster]:!border-l-info-dark-1 group-[.toaster]:shadow-md group-[.toaster]:rounded-r-md group-[.toaster]:font-semibold [&_*]:!text-info-dark-1',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
